import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import LogoComponent from '@ui/components/Logo/Logo.component';
import { brandConfig, brandLogoSrc } from '@config/brand.config';
import useDictionary from '@ui/hooks/useDictionary';
import LoginWrapContainer from '../Login/Login-wrap.container';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    cookies,
    authenticationVisible,
    registerVisible,
    passRecoveryVisible,
    onAuthenticationClose,
    onAuthenticationOpen,
    onDemoClick,
    onBtnKeyDown,
}: IProps) => {
    const getWord = useDictionary();

    const authContent = (
        <>
            <Box className="auth" component="section">
                <Box
                    className={
                        cookies ? 'auth__grid_with-cookies' : 'auth__grid'
                    }
                >
                    <Box className="auth__col">
                        <Box className="auth__main-header">
                            {!brandConfig.logo.auth.hidden && (
                                <Box
                                    className="header__logo"
                                    component="img"
                                    src={brandLogoSrc(
                                        brandConfig.logo.auth,
                                        lang,
                                    )}
                                    width={brandConfig.logo.auth.width}
                                    height={brandConfig.logo.auth.height}
                                />
                            )}
                            {/* <Box className="auth__logo">
                                <LogoComponent
                                    variant="auth"
                                    lang={lang}
                                    full
                                />
                            </Box> */}
                            <Typography className="auth__text" variant="body1">
                                {getWord('authMainText')}
                            </Typography>
                        </Box>
                        <ButtonBarComponent>
                            <ButtonComponent
                                label="signIn"
                                color="primaryAuth"
                                lang={lang}
                                onClick={onAuthenticationOpen}
                                onKeyDown={onBtnKeyDown}
                            />
                            <ButtonComponent
                                label="demo"
                                color="demo"
                                lang={lang}
                                onClick={onDemoClick}
                                onKeyDown={onBtnKeyDown}
                            />
                        </ButtonBarComponent>
                    </Box>
                </Box>
            </Box>
        </>
    );

    return (
        <>
            {authContent}
            <Modal
                open={
                    authenticationVisible ||
                    registerVisible ||
                    passRecoveryVisible
                }
                onClose={onAuthenticationClose}
            >
                <LoginWrapContainer onClose={onAuthenticationClose} />
            </Modal>
        </>
    );
};

const AuthComponent = React.memo(Component);

export default AuthComponent;
